import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'pick-time-range',
  templateUrl: './pick-time-range.component.html',
  styleUrls: ['./pick-time-range.component.scss'],
  standalone: false,
})
export class PickTimeRangeComponent {
  @Input() allDay: boolean;
  @Input() startTime: Date;
  @Input() endTime: Date;
  @Input() isUTC: boolean;
  @Output() allDayChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() startTimeChange: EventEmitter<Date> = new EventEmitter<Date>();
  @Output() endTimeChange: EventEmitter<Date> = new EventEmitter<Date>();

  private previousStartTime: Date | null = null;
  private previousEndTime: Date | null = null;

  constructor() {}

  updateAllDay(value: boolean) {
    if (value) {
      this.previousStartTime = this.startTime ?? null;
      this.previousEndTime = this.endTime ?? null;
      this.startTime = null;
      this.endTime = null;
      this.startTimeChange.emit(null);
      this.endTimeChange.emit(null);
    } else if (this.previousStartTime || this.previousEndTime) {
      this.startTime = this.previousStartTime;
      this.endTime = this.previousEndTime;
      this.startTimeChange.emit(this.startTime);
      this.endTimeChange.emit(this.endTime);
      this.previousStartTime = null;
      this.previousEndTime = null;
    }

    this.allDay = value;
    this.allDayChange.emit(value);
  }

  updateStartTime() {
    this.startTimeChange.emit(this.startTime);
  }

  updateEndTime() {
    this.endTimeChange.emit(this.endTime);
  }
}
